import { Fredoka_500Medium, Fredoka_600SemiBold } from '@expo-google-fonts/fredoka';
import {
  Sora_400Regular,
  Sora_500Medium,
  Sora_600SemiBold,
  Sora_700Bold,
  Sora_800ExtraBold,
} from '@expo-google-fonts/sora';
import { useFonts } from 'expo-font';
import { Stack } from 'expo-router';
import * as SplashScreen from 'expo-splash-screen';
import { useEffect } from 'react';
import { StatusBar } from 'expo-status-bar';
import BarraSistema from '@/components/BarraSistema';
import LoginGate from '@/components/LoginGate';
import { C } from '@/constants/theme';
import { RoleProvider } from '@/context/RoleContext';

export { ErrorBoundary } from 'expo-router';

SplashScreen.preventAutoHideAsync();

export default function RootLayout() {
  const [loaded, error] = useFonts({
    Fredoka_500Medium,
    Fredoka_600SemiBold,
    Sora_400Regular,
    Sora_500Medium,
    Sora_600SemiBold,
    Sora_700Bold,
    Sora_800ExtraBold,
  });

  useEffect(() => {
    if (error) throw error;
  }, [error]);

  useEffect(() => {
    if (loaded) SplashScreen.hideAsync();
  }, [loaded]);

  if (!loaded) return null;

  return (
    <>
      <StatusBar style="light" />
      {/* La barra de botones de Android, del color de la app y no blanca. */}
      <BarraSistema />
      <LoginGate>
        {(sesion, salir, capacidades, rolServidor, rolesServidor) => (
          <RoleProvider sesion={sesion} onSalir={salir} capacidades={capacidades}
            rolServidor={rolServidor} rolesServidor={rolesServidor}>
            <Stack screenOptions={{ headerShown: false, contentStyle: { backgroundColor: C.bg } }}>
              <Stack.Screen name="(tabs)" />
            </Stack>
          </RoleProvider>
        )}
      </LoginGate>
    </>
  );
}
